// Neha Kumari : 08-08-23  : BT-107433 - Fibonacci calculator calculation start
// ---BT-107433_SrikanthRao_9-10-2023_Calculator || Functional Implementation
import { FIBONACCI_TREND, FIBONACCI_RETREACEEXT } from "../../utils/global_variables";
let uptrendExtension = 0;
let uptrendRetracement = 0;
let downtrendRetracement = 0;
let downtrendExtension = 0;

export const _calculateFibonacciLevels = (arrStandardRetracementLevels, arrStandardExtensionLevels, calculatorInputs, toggleUptrendDowntrendBtn, toggleRetracementExtensionBtn, decimalLocatorLength) => {
    //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - Start
    const arrUptrendExtension = [];
    const arrUptrendRetracement = [];
    const arrDowntrendRetracement = [];
    const arrDowntrendExtension = [];
    //for uptrend extension -> UE
    if (toggleUptrendDowntrendBtn === FIBONACCI_TREND.UPTREND && toggleRetracementExtensionBtn === FIBONACCI_RETREACEEXT.EXTENSION) {
        for (let i = 0; i < arrStandardExtensionLevels.length; i++) {
            uptrendExtension = Number(calculatorInputs?.fibonacciHighPrice) + ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardExtensionLevels[i]);
            arrUptrendExtension.push(uptrendExtension.toFixed(decimalLocatorLength));
        }
        return arrUptrendExtension;
    }
    //for uptrend retracement -> UR
    else if (toggleUptrendDowntrendBtn === FIBONACCI_TREND.UPTREND && toggleRetracementExtensionBtn === FIBONACCI_RETREACEEXT.RETRACEMENT) {
        for (let i = 0; i < arrStandardRetracementLevels.length; i++) {
            uptrendRetracement = Number(calculatorInputs?.fibonacciHighPrice) - ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardRetracementLevels[i]);
            arrUptrendRetracement.push(uptrendRetracement.toFixed(decimalLocatorLength));
        }
        return arrUptrendRetracement;
    }
    // for downtrend retracement -> DR
    else if (toggleUptrendDowntrendBtn === FIBONACCI_TREND.DOWNTREND && toggleRetracementExtensionBtn === FIBONACCI_RETREACEEXT.RETRACEMENT) {
        for (let i = 0; i < arrStandardRetracementLevels.length; i++) {
            downtrendRetracement = Number(calculatorInputs?.fibonacciLowPrice) + ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardRetracementLevels[i]);
            arrDowntrendRetracement.push(downtrendRetracement.toFixed(decimalLocatorLength));
        }
        return arrDowntrendRetracement;
    }
    // for downtrend extension -> DE
    else if (toggleUptrendDowntrendBtn === FIBONACCI_TREND.DOWNTREND && toggleRetracementExtensionBtn === FIBONACCI_RETREACEEXT.EXTENSION) {
        for (let i = 0; i < arrStandardExtensionLevels.length; i++) {
            downtrendExtension = Number(calculatorInputs?.fibonacciLowPrice) - ((Number(calculatorInputs?.fibonacciHighPrice) - Number(calculatorInputs?.fibonacciLowPrice)) * arrStandardExtensionLevels[i]);
            arrDowntrendExtension.push(downtrendExtension.toFixed(decimalLocatorLength));
        }
        return arrDowntrendExtension;
        //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - End
    } else { }
};
// // Neha Kumari : 08-08-23  : BT-107433 - Fibonacci calculator calculation start

export const _validateFibonacciValues = (obj) => {


    let objValidateWarnings = {

        fibonacciHighPrice: false,
        fibonacciLowPrice: false,
        priceDifference: false,
        calculate: false,
    };

    try {


        if (obj.fibonacciHighPrice === undefined || obj.fibonacciHighPrice == null || obj.fibonacciHighPrice <= 0) {
            objValidateWarnings.fibonacciHighPrice = true;


        };
        if (obj.fibonacciLowPrice === undefined || obj.fibonacciLowPrice == null || obj.fibonacciLowPrice <= 0) {
            objValidateWarnings.fibonacciLowPrice = true;


        };

        return objValidateWarnings;

    } catch (error) {
        console.log("error", error);

    }

};